export function refRem () {
  let desW = 640
  let winW = document.documentElement.clientWidth
  let ratio = winW / desW
  document.documentElement.style.fontSize = ratio * 100 + 'px'
}
refRem()
window.addEventListener('resize', refRem)



// WEBPACK FOOTER //
// ./src/rem.js